<template>
  <v-layout class="mx-3 mt-4">
    <v-btn
      flat
      color="error"
      round
      outline
      class="initialize"
      @click="doShowDeleteReservationModal"
      v-if="isModifiable"
    >
      {{ $t('global.button.remove') }}</v-btn
    >

    <v-spacer></v-spacer>

    <v-btn
      flat
      color="primary"
      round
      outline
      class="initialize"
      @click="doEditReservation"
      v-if="isModifiable"
    >
      {{ $t('global.button.edit') }}</v-btn
    >

    <v-menu bottom left min-width="200">
      <template v-slot:activator="{ on }">
        <v-btn flat color="primary" round outline class="initialize" v-on="on">
          {{ $t('global.button.ticket') }}
        </v-btn>
      </template>

      <v-list class="initialize">
        <v-list-tile
          @click="downloadTicket(true)"
          class="pointer"
          :disabled="ticketDowloadLoading"
        >
          <v-list-tile-title class="body-1 grey--text text--darken-1">
            {{ $t('reservation.ticket.button.email') }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="downloadTicket(false)"
          class="pointer"
          :disabled="ticketEmailLoading"
        >
          <v-list-tile-title class="body-1 grey--text text--darken-1">
            {{ $t('reservation.ticket.button.download') }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <delete-reservation-modal
      v-if="showDeleteReservationModal"
      :booking="booking"
      @on-close="closeDeleteReservationModal"
    ></delete-reservation-modal>
  </v-layout>
</template>

<script>
// import reservationService from '@/services/reservationService';
import ticketService from '@/services/ticketService';
import manageErrorService from '@/services/manageErrorService';
import DeleteReservationModal from '@/components/private/booking/DeleteReservationModal';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import store from '@/store';

export default {
  name: 'BookingButtons',
  components: {
    [DeleteReservationModal.name]: DeleteReservationModal
  },
  props: {
    booking: {
      type: Object,
      required: true
    }
  },
  computed: {
    isModifiable() {
      return !(
        this.isSubscription ||
        this.booking.status === 'PAID' ||
        this.booking.status === 'IN_USE'
      );
    },
    isSubscription() {
      return this.booking.type === 'SUBSCRIPTION';
    },
    username() {
      return store.state.user.username;
    }
  },
  data() {
    return {
      showDeleteReservationModal: false,
      ticketEmailLoading: false,
      ticketDowloadLoading: false
    };
  },
  methods: {
    doShowDeleteReservationModal() {
      this.showDeleteReservationModal = true;
    },
    closeDeleteReservationModal() {
      this.showDeleteReservationModal = false;
    },
    doEditReservation() {
      EventBus.$emit(keys.showReservationDetail);
    },
    async downloadTicket(sendByEmail) {
      this.ticketEmailLoading = true;
      this.ticketDowloadLoading = true;

      let params = {
        reservationId: this.booking.id
      };

      let results;
      let msg;
      if (sendByEmail) {
        results = await ticketService.sendEmail(params);
        msg = this.$i18n.t('ticket.toast.sendByEmail.success', {
          username: this.username
        });
      } else {
        let filename = this.$i18n.t('ticket.filename');
        results = await ticketService.downloadFile(params, filename);
        msg = this.$i18n.t('ticket.toast.downloadFile.success');
      }

      if (results.error) {
        manageErrorService.handle(results.data);
        this.ticketEmailLoading = true;
        this.ticketDowloadLoading = true;
        return;
      }

      this.ticketEmailLoading = false;
      this.ticketDowloadLoading = false;

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: msg,
        type: 'success',
        doNotTranslate: true
      });
    }
  }
};
</script>
